export default {
  nav: {
    dashboard: "Панель", forms: "Формы", roadmaps: "Маршруты", documents: "Документы",
    timeline: "Сроки", checklists: "Списки", deadlines: "Дедлайны",
    pricing: "Цены", guides: "Руководства", dmvGuide: "Водительские права",
    signIn: "Войти", startFree: "Бесплатное руководство", startFreeShort: "Начать",
    profile: "Профиль", logOut: "Выйти",
  },
  footer: {
    tagline: "Пошаговая навигация с ИИ для иммиграционных процессов в США.",
    product: "Продукт", tools: "Инструменты", legal: "Правовая информация",
    greenCard: "Грин-карта", timelineCalc: "Калькулятор сроков",
    dvLottery: "Лотерея DV",
    privacy: "Политика конфиденциальности", terms: "Условия использования", contact: "Контакты",
    disclaimer: "ImmigrationGuide не является юридической фирмой и не предоставляет юридических консультаций. Данный инструмент предоставляет только общую информационную помощь.",
  },
  landing: {
    badge: "ИИ-навигатор для иммиграции в США",
    title: "Иммиграция в США",
    titleHighlight: "с уверенностью",
    subtitle: "Пошаговое руководство с ИИ для форм USCIS, Social Security и водительских прав. Без юридического жаргона. Без путаницы. Только понятная помощь.",
    ctaStart: "Бесплатное руководство", ctaBrowse: "Все руководства",
    socialProof: "форм заполнено в этом месяце",
    popularTitle: "Самые популярные руководства по иммиграции", popularLabel: "Популярные руководства",
    howTitle: "Три простых шага", howLabel: "Как это работает",
    howSteps: [
      { num: "01", title: "Выберите процесс", desc: "Выберите из форм USCIS, заявлений Social Security или руководств по водительским правам." },
      { num: "02", title: "Получите помощь ИИ", desc: "Наш ИИ объясняет каждое поле простым языком и помогает заполнить правильно." },
      { num: "03", title: "Подавайте с уверенностью", desc: "Проверьте анализ ИИ, выявите ошибки заранее и узнайте, какие документы нужны." },
    ],
    featLabel: "Возможности", featTitle: "Всё необходимое для навигации по иммиграции",
    features: [
      { title: "Пошаговый помощник с ИИ", desc: "Интерактивное руководство проведёт вас по каждому полю формы с понятными пояснениями." },
      { title: "Анализ с ИИ", desc: "Получите персональные рекомендации, возможные проблемы и советы после заполнения форм." },
      { title: "Загрузка и проверка документов", desc: "Загрузите документы, и ИИ проверит их на недостающие файлы и несоответствия." },
      { title: "Хронология процесса", desc: "Визуальный трекер, показывающий, на каком этапе иммиграционного процесса вы находитесь." },
      { title: "Персональные списки", desc: "Списки документов, созданные ИИ на основе вашего типа визы и ситуации." },
      { title: "Отслеживание сроков", desc: "Никогда не пропустите срок подачи благодаря умному отслеживанию и напоминаниям." },
    ],
    pricingLabel: "Цены", pricingTitle: "Начните бесплатно, обновите когда будете готовы",
    free: "Бесплатно", freePer: "/мес",
    freeFeatures: ["Доступ ко всем руководствам", "Базовый помощник с ИИ", "Маршруты процессов", "Информация сообщества"],
    pro: "Премиум", proPer: "/мес", proBadge: "Самый популярный",
    proFeatures: ["Анализ и рекомендации ИИ", "Проверка документов", "Отслеживание хронологии", "Персональные списки", "Отслеживание сроков", "Приоритетная поддержка"],
    valueStatement: "Откройте проверку документов с ИИ, которая находит ошибки до отправки.",
    compTitle: "Сравнение планов",
    proCtaStart: "Начать Премиум",
    ctaTitle: "Готовы начать свой иммиграционный путь?",
    ctaSubtitle: "Присоединяйтесь к тысячам иммигрантов, которые используют ImmigrationGuide для навигации по государственным формам США с уверенностью.",
    heroDisclaimer: "ImmigrationGuide не является юридической фирмой и не предоставляет юридических консультаций.",
    qualitativeProof: "Пошаговое руководство для I-485, I-130, I-765, SS-5 и процессов DMV",
    dvLotteryName: "Лотерея DV",
    dvLotteryDesc: "Право на участие и руководство по программе Diversity Visa",
    faqLabel: "Частые вопросы",
    faqTitle: "Частые вопросы",
    faq1Q: "Мои данные в безопасности?",
    faq1A: "Да. Все данные шифруются при передаче (TLS) и хранении (AES-256). Мы никогда не храним вашу информацию в открытом виде, и вы можете запросить полное удаление данных в любое время.",
    faq2Q: "Вы связаны с USCIS?",
    faq2A: "Нет. ImmigrationGuide — это независимая образовательная платформа. Мы не связаны с USCIS, Государственным департаментом или какими-либо государственными органами. Мы никогда не передаём ваши данные государственным органам.",
    faq3Q: "Что происходит с загруженными документами?",
    faq3A: "Документы хранятся в зашифрованном виде и используются только для проверки форм с помощью ИИ. Они никогда не передаются третьим лицам. Вы можете удалить все загруженные файлы в любое время на странице Документы.",
    pricingValue: "Откройте проверку документов с ИИ, которая находит ошибки до отправки.",
    compFeature: "Функция",
    compPrice: "Цена",
    compFeatures: ["Пошаговый помощник", "Персональный список", "Визуальная хронология", "Проверка форм с ИИ", "Загрузка и валидация документов", "Отслеживание сроков и напоминания", "Управление несколькими формами", "Приоритетная поддержка"],
  },
  gc: {
    badge: "Полное руководство по Грин-карте", title: "Руководство по Грин-карте", titleHighlight: "для иммигрантов",
    subtitle: "Пошаговая помощь с формами, документами, сроками и типичными ошибками. Разберитесь в каждом этапе получения постоянного вида на жительство в США.",
    ctaStart: "Бесплатное руководство", ctaTimeline: "Сроки получения Грин-карты",
    whatTitle: "Что такое Грин-карта?",
    whatP1: "Грин-карта (официально — Карта постоянного резидента) даёт вам разрешение жить и работать в США на постоянной основе. Это самый распространённый путь к получению гражданства США.",
    whatP2: "Как обладатель Грин-карты, вы можете работать на любого работодателя, свободно путешествовать, спонсировать определённых членов семьи и, выполнив требования к проживанию, подать заявление на гражданство США через натурализацию.",
    pathsLabel: "Право на получение", pathsTitle: "Основные пути получения Грин-карты",
    paths: [
      { title: "По семейной линии", desc: "Спонсирование супругом, родителем, ребёнком или братом/сестрой — гражданином или резидентом США." },
      { title: "По рабочей линии", desc: "Спонсирование американским работодателем через трудовую сертификацию или специальные категории (EB-1 — EB-5)." },
      { title: "Изменение статуса", desc: "Подайте заявление на Грин-карту, находясь на территории США (Форма I-485)." },
      { title: "Консульская обработка", desc: "Подайте через посольство или консульство США в вашей стране после одобрения петиции." },
      { title: "Специальные категории", desc: "Лотерея виз, статус беженца/убежище, VAWA и другие гуманитарные программы." },
    ],
    formsLabel: "Формы", formsTitle: "Наиболее распространённые формы для Грин-карты",
    openGuide: "Открыть руководство", startWizard: "Начать помощник", browseGuides: "Все руководства",
    forms: [
      { code: "I-130", name: "Петиция о родственнике-иностранце", desc: "Подаётся гражданином или резидентом США для подтверждения родственных отношений с иностранным родственником." },
      { code: "I-485", name: "Изменение статуса", desc: "Заявление на получение статуса постоянного резидента, находясь на территории США." },
      { code: "I-765", name: "Разрешение на работу", desc: "Заявление на получение разрешения на работу (EAD), чтобы легально работать пока Грин-карта рассматривается." },
      { code: "I-864", name: "Аффидавит о поддержке", desc: "Ваш спонсор подтверждает, что имеет достаточный доход для вашего финансового обеспечения в США." },
      { code: "I-693", name: "Медицинское обследование", desc: "Пройдите медосмотр у врача, назначенного USCIS, для подтверждения соответствия требованиям здоровья." },
    ],
    processLabel: "Процесс", processTitle: "Пошаговый процесс получения Грин-карты",
    processSteps: [
      { title: "Определить право на получение", desc: "Определите, какая категория Грин-карты применима к вашему случаю." },
      { title: "Подать иммиграционную петицию", desc: "Ваш спонсор подаёт Форму I-130 (семья) или I-140 (работа) в USCIS." },
      { title: "Ожидание приоритетной даты", desc: "Если в вашей категории есть очередь, дождитесь, пока ваша дата станет актуальной." },
      { title: "Подать I-485 или консульская обработка", desc: "Подайте заявление на изменение статуса (I-485) или пройдите консульскую обработку за рубежом." },
      { title: "Биометрическая проверка", desc: "Посетите центр поддержки USCIS для снятия отпечатков пальцев и фото." },
      { title: "Прохождение интервью", desc: "Встретьтесь с офицером USCIS или консульства для рассмотрения вашего заявления." },
      { title: "Получение решения", desc: "USCIS одобряет, отклоняет или запрашивает дополнительные доказательства." },
      { title: "Получение Грин-карты", desc: "В случае одобрения ваша карта постоянного резидента будет отправлена по почте на ваш адрес в США." },
    ],
    startGuidedWizard: "Начать пошаговый помощник",
    docsLabel: "Документы", docsTitle: "Список необходимых документов",
    docs: [
      "Действующий паспорт (все заявители)", "Свидетельство о рождении с заверенным переводом на английский",
      "Свидетельство о браке (если применимо)", "Свидетельства о разводе или смерти от предыдущих браков",
      "Уведомление об одобрении Формы I-130", "Форма I-864 Аффидавит о поддержке + налоговые декларации",
      "Две фотографии паспортного формата", "Запечатанное медицинское заключение I-693",
      "Справки о несудимости", "Письмо от работодателя или доказательства финансовой поддержки",
      "Доказательства подлинности отношений (фото, переписка, договоры аренды)", "Копия документов о текущем иммиграционном статусе (виза, I-94)",
    ],
    checklistCtaTitle: "Нужен персональный список?",
    checklistCtaDesc: "Наш ИИ создаст персональный список документов на основе вашего типа визы, семейного положения и страны.",
    generateChecklist: "Создать мой список",
    mistakesLabel: "Избегайте этого", mistakesTitle: "Типичные ошибки при подаче на Грин-карту",
    mistakes: [
      "Подача неподписанных или неполных форм", "Использование устаревших версий форм (всегда скачивайте с uscis.gov)",
      "Забыли приложить правильную пошлину", "Несогласованные даты в разных формах",
      "Не перевели документы на иностранном языке на английский", "Пропуск биометрической проверки без переноса",
      "Не раскрыли предыдущие иммиграционные нарушения", "Отправка заявления по неверному адресу USCIS",
      "Недостаточно доказательств подлинности отношений", "Истечение срока разрешения на работу во время ожидания",
    ],
    checkDocs: "Проверить мои документы с ИИ",
    timelineLabel: "Сроки", timelineTitle: "Сроки получения Грин-карты",
    timelineDesc: "Оцените, сколько времени может занять ваш процесс получения Грин-карты на основе вашей категории и ситуации.",
    timelineCta: "Калькулятор сроков Грин-карты",
    immediateRelatives: "Ближайшие родственники", familyPreference: "Семейная категория", employmentBased: "По рабочей линии",
    faqLabel: "Вопросы и ответы", faqTitle: "Часто задаваемые вопросы о Грин-карте",
    faqs: [
      { q: "Сколько времени занимает получение Грин-карты?", a: "Сроки сильно различаются. Ближайшие родственники граждан США обычно ждут 12-18 месяцев. Семейные и рабочие категории могут занять 2-10+ лет в зависимости от категории и страны происхождения." },
      { q: "В чём разница между I-130 и I-485?", a: "Форма I-130 — это иммиграционная петиция, устанавливающая ваши родственные отношения со спонсором. Форма I-485 — заявление на изменение статуса для получения постоянного вида на жительство. Для семейной Грин-карты нужны обе формы." },
      { q: "Могу ли я работать, пока заявление рассматривается?", a: "Да. Вы можете подать Форму I-765 (заявление на разрешение на работу) вместе с I-485. После одобрения вы получите EAD — документ, позволяющий работать легально." },
      { q: "Сколько стоит подача на Грин-карту?", a: "Пошлина за I-485 составляет $1,225 для заявителей от 14 лет (включая биометрию). Петиция I-130 стоит $535. Общая стоимость обычно от $2,000 до $5,000+." },
      { q: "Что происходит на интервью?", a: "Офицер USCIS рассматривает ваше заявление, задаёт вопросы, проверяет документы и принимает решение. Интервью обычно длится 15-30 минут." },
      { q: "Можно ли путешествовать, пока Грин-карта рассматривается?", a: "Не выезжайте из США без документа Advance Parole (Форма I-131). Выезд без него может считаться отказом от заявления I-485." },
      { q: "Что такое приоритетная дата?", a: "Приоритетная дата — это дата подачи вашей иммиграционной петиции (I-130 или I-140). Для категорий с годовыми лимитами нужно ждать, пока ваша дата станет 'актуальной'." },
      { q: "Что делать, если заявление отклонено?", a: "Вы можете подать ходатайство о пересмотре, обжаловать в BIA или подать заново. Уведомление об отказе объяснит причину и ваши варианты. Рекомендуется проконсультироваться с иммиграционным адвокатом." },
    ],
    finalTitle: "Готовы начать процесс получения Грин-карты?",
    finalSubtitle: "ImmigrationGuide проведёт вас через каждую форму, документ и шаг. Начните бесплатно — кредитная карта не требуется.",
  },
  gct: {
    badge: "Калькулятор сроков", title: "Грин-карта", titleHighlight: "Калькулятор сроков",
    subtitle: "Оцените, сколько времени может занять ваш процесс получения Грин-карты.",
    ctaStart: "Рассчитать сроки", ctaGuide: "Руководство по Грин-карте",
    howTitle: "Как работают сроки Грин-карты",
    howP1: "Сроки обработки Грин-карт сильно различаются и зависят от нескольких факторов:",
    howFactors: ["Иммиграционная категория (семья или работа)", "Страна рождения", "Доступность виз (годовые лимиты)", "Скорость обработки USCIS", "Ваша приоритетная дата"],
    calcLabel: "Калькулятор", calcTitle: "Рассчитайте сроки вашей Грин-карты",
    calcCategory: "Категория Грин-карты", calcCategoryPh: "Выберите категорию...",
    calcCountry: "Страна рождения", calcCountryPh: "Выберите страну рождения...",
    calcProcessing: "Тип обработки", calcProcessingPh: "Выберите тип обработки...",
    calcFamilyLabel: "По семейной линии", calcEmploymentLabel: "По рабочей линии",
    calcButton: "Рассчитать сроки",
    resultLabel: "Ориентировочные сроки", resultStepsTitle: "Ориентировочные этапы процесса",
    resultSteps: ["Подача петиции", "Одобрение петиции", "Доступность визы", "Изменение статуса / Консульская обработка", "Интервью", "Одобрение Грин-карты"],
    resultFromStart: "с начала",
    resultDisclaimer: "Это оценки на основе исторических данных USCIS. Фактические сроки могут отличаться.",
    resultTrack: "Отслеживать прогресс", resultRecalc: "Пересчитать",
    rangesLabel: "Сроки обработки", rangesTitle: "Типичные сроки обработки Грин-карты",
    delaysLabel: "Задержки", delaysTitle: "Частые причины задержек",
    delays: [
      { title: "Недостающие или неполные документы", desc: "USCIS выдаёт запрос на доказательства (RFE), что может добавить 2-4 месяца." },
      { title: "Задержка визового бюллетеня", desc: "Ваша приоритетная дата должна стать актуальной для рассмотрения дела." },
      { title: "Запрос на доказательства (RFE)", desc: "Если USCIS нужна дополнительная информация, дело приостанавливается. Обычно даётся 87 дней." },
      { title: "Проверка биографии", desc: "Проверки безопасности могут вызвать непредсказуемые задержки." },
      { title: "Задержки назначения интервью", desc: "Некоторые офисы USCIS имеют длинные очереди." },
      { title: "COVID или изменения политики", desc: "Государственные закрытия или чрезвычайные ситуации могут временно остановить обработку." },
    ],
    checkDocs: "Проверить мои документы",
    guideLinkTitle: "Разберитесь в полном процессе Грин-карты", guideLinkDesc: "Наше руководство объясняет каждую форму, документ и шаг.",
    guideLinkCta: "Открыть руководство по Грин-карте",
    faqLabel: "Вопросы и ответы", faqTitle: "Вопросы о сроках Грин-карты",
    faqs: [
      { q: "Сколько времени занимает Грин-карта?", a: "Зависит от категории и страны рождения. Ближайшие родственники — 12-18 мес. Семейные категории — 2-25+ лет. Рабочие — 1-15 лет." },
      { q: "Что влияет на сроки обработки?", a: "Категория, страна рождения, доступность виз и скорость обработки USCIS." },
      { q: "Что такое приоритетная дата?", a: "Дата подачи вашей петиции. Дело не может продвигаться, пока дата не станет 'актуальной' по визовому бюллетеню." },
      { q: "Почему важна страна рождения?", a: "Закон ограничивает количество Грин-карт на страну в год (~7% от общего числа). Страны с высоким спросом имеют многолетние очереди." },
      { q: "Сколько ждать интервью после биометрии?", a: "Обычно 2-8 месяцев, в зависимости от вашего местного офиса USCIS." },
    ],
    visaBulletinBadge: "Скоро", visaBulletinTitle: "Предсказатель визового бюллетеня",
    visaBulletinDesc: "Прогноз приоритетной даты, оценка ожидания и прогноз задержек по странам.",
    visaBulletinCta: "Получить уведомление",
    finalTitle: "Начните процесс Грин-карты с ImmigrationGuide",
    finalSubtitle: "Пошаговая помощь ИИ для каждой формы, документа и срока. Начните бесплатно.",
    finalStart: "Бесплатное руководство", finalChecklist: "Создать мой список",
  },
  guides: {
    badge: "Руководства по иммиграции", title: "Полные руководства по иммиграции в США",
    subtitle: "Пошаговые руководства по каждой форме. Бесплатные пояснения, необходимые документы, типичные ошибки и помощь ИИ.",
    immigration: "Иммиграция", govServices: "Государственные услуги", dmv: "Водительские права",
    greenCard: "Грин-карта",
    greenCardDesc: "Заявление на регистрацию постоянного проживания",
    familyPetition: "Семейная петиция",
    familyPetitionDesc: "Петиция для родственника-иностранца",
    workAuth: "Разрешение на работу",
    workAuthDesc: "Заявление на разрешение на трудоустройство",
    ssCard: "Социальное обеспечение",
    ssCardDesc: "Заявление на карту социального обеспечения",
    dmvGuide: "Водительские права",
    dmvGuideDesc: "Требования по штатам для иммигрантов",
  },
  privacy: {
    title: "Политика конфиденциальности", updated: "Последнее обновление: Февраль 2026",
    sections: [
      { title: "1. Какую информацию мы собираем", body: "При создании аккаунта мы собираем ваше имя, адрес электронной почты и пароль (хранится в защищённом хеше). При входе через Google мы получаем ваше имя, email и фото профиля.\n\nПри использовании наших инструментов мы сохраняем ответы в помощнике, метаданные загруженных документов, сроки и настройки списков." },
      { title: "2. Загруженные документы", body: "Файлы хранятся на защищённых серверах. ИИ анализирует метаданные для проверки полноты. Мы не продаём и не передаём ваши документы третьим лицам." },
      { title: "3. Как мы используем информацию", body: "Мы используем информацию для предоставления сервиса ImmigrationGuide: персональных списков, помощника с ИИ, отслеживания хронологии и напоминаний о сроках." },
      { title: "4. Аутентификация", body: "Мы предлагаем два способа входа: email/пароль (bcrypt + JWT) и Google OAuth. Мы не храним ваш пароль Google." },
      { title: "5. Аналитика и файлы cookie", body: "Мы используем базовую аналитику продукта. Файлы cookie сессии используются для поддержания входа. Мы не используем рекламные трекеры." },
      { title: "6. Передача данных", body: "Мы не продаём ваши данные. Передаём только провайдеру ИИ (OpenAI) и хостинг-провайдерам по необходимости." },
      { title: "7. Ваши права", body: "Вы можете запросить доступ, исправление или удаление ваших данных. Вы можете удалить аккаунт в любое время." },
      { title: "8. Контакты", body: "По вопросам конфиденциальности: support@immigrationguide.us." },
    ],
  },
  terms: {
    title: "Условия использования", updated: "Последнее обновление: Февраль 2026",
    sections: [
      { title: "1. Описание сервиса", body: "ImmigrationGuide — онлайн-платформа с ИИ для информационной помощи по иммиграционным формам и государственным процессам США." },
      { title: "2. Не является юридической консультацией", body: "ImmigrationGuide не является юридической фирмой. Информация предоставляется исключительно в образовательных и информационных целях. Всегда проверяйте на uscis.gov и консультируйтесь с иммиграционным адвокатом." },
      { title: "3. Обязанности пользователя", body: "Вы несёте ответственность за точность предоставленной информации и её проверку перед подачей в государственные органы." },
      { title: "4. Аккаунты", body: "Предоставляйте точную информацию при создании аккаунта. Вы несёте ответственность за всю активность в аккаунте." },
      { title: "5. Подписка и оплата", body: "Мы предлагаем бесплатный и премиум-планы. Подписки продлеваются автоматически. Отменить можно в любое время." },
      { title: "6. Контент, созданный ИИ", body: "Наши инструменты ИИ генерируют рекомендации на основе общих знаний об иммиграции. Контент может содержать ошибки. Не полагайтесь исключительно на него." },
      { title: "7. Ограничение ответственности", body: "В максимальной степени, разрешённой законом, мы не несём ответственности за косвенные или последующие убытки. Общая ответственность не превышает сумму, уплаченную за последние 12 месяцев." },
      { title: "8. Интеллектуальная собственность", body: "Весь контент и технология принадлежат нам. Вы сохраняете право собственности на свои данные и документы." },
      { title: "9. Изменения условий", body: "Мы можем обновлять условия. Зарегистрированные пользователи будут уведомлены о существенных изменениях." },
      { title: "10. Контакты", body: "По вопросам об условиях: support@immigrationguide.us." },
    ],
  },
  contact: {
    title: "Свяжитесь с нами", subtitle: "Есть вопрос или нужна помощь? Напишите нам, и мы ответим как можно скорее.",
    email: "Электронная почта", responseTime: "Время ответа", responseValue: "В течение 24 часов",
    name: "Имя", namePh: "Ваше имя", emailLabel: "Электронная почта", emailPh: "вы@пример.com",
    message: "Сообщение", messagePh: "Чем мы можем помочь?",
    send: "Отправить", successTitle: "Сообщение отправлено",
    successDesc: "Спасибо за обращение. Мы ответим в течение 24 часов.",
    sendAnother: "Отправить ещё",
  },
  dvl: {
    badge: "Гид по программе DV",
    title: "Лотерея Грин-карт",
    titleHighlight: "(Программа DV) Гид",
    subtitle: "Узнайте, как работает лотерея DV, кто может участвовать, ключевые даты и как подготовить заявку.",
    ctaEligibility: "Проверить право на участие",
    ctaStart: "Бесплатный гид по иммиграции",
    whatTitle: "Что такое лотерея Грин-карт?",
    whatP1: "Лотерея DV (Diversity Visa) — также известная как лотерея Грин-карт — это программа правительства США, предоставляющая до 55 000 иммиграционных виз ежегодно гражданам стран с исторически низким уровнем иммиграции в США.",
    whatP2: "Заявители отбираются случайным образом с помощью компьютерного розыгрыша. Победители и их семьи могут подать заявку на постоянное проживание (грин-карту) для жизни и работы в США.",
    whatHighlights: [
      { num: "55 000", label: "Грин-карт выдаётся в год" },
      { num: "Случайный", label: "Компьютерный отбор" },
      { num: "Бесплатно", label: "Без платы за регистрацию" },
    ],
    datesLabel: "Ключевые даты",
    datesTitle: "Ключевые даты лотереи DV",
    dates: [
      { period: "Октябрь – Ноябрь", title: "Период регистрации", desc: "Окно онлайн-регистрации на dvprogram.state.gov обычно открывается в начале октября и закрывается в начале ноября." },
      { period: "Май", title: "Объявление результатов", desc: "Участники могут проверить статус отбора онлайн начиная с мая, используя номер подтверждения." },
      { period: "Октябрь – Сентябрь", title: "Обработка визы", desc: "Отобранные заявители проходят обработку визы в течение финансового года: подача форм, собеседование, медосмотр." },
    ],
    ctaTimeline: "Посмотреть хронологию Грин-карты",
    eligLabel: "Право участия",
    eligTitle: "Кто может участвовать в лотерее DV?",
    eligIntro: "Для участия в лотерее DV заявители должны соответствовать следующим требованиям:",
    eligReqs: [
      { title: "Страна рождения", desc: "Вы должны родиться в подходящей стране. Страны с более чем 50 000 иммигрантов за последние 5 лет исключены." },
      { title: "Требование к образованию", desc: "Необходимо среднее образование или эквивалент (12 лет), ИЛИ два года квалифицированного опыта работы." },
      { title: "Альтернатива — опыт работы", desc: "Если вы не соответствуете требованиям к образованию, можете квалифицироваться с двумя годами опыта работы." },
      { title: "Требования к фотографии", desc: "Необходимо предоставить фотографию: 600×600 пикселей, белый фон, без очков, сделанную в последние 6 месяцев." },
    ],
    howLabel: "Процесс подачи",
    howTitle: "Как подать заявку на лотерею Грин-карт",
    howSteps: [
      { title: "Зарегистрируйтесь на официальном сайте", desc: "Перейдите на dvprogram.state.gov в период регистрации. Это единственный легитимный сайт." },
      { title: "Отправьте личную информацию", desc: "Укажите имя, дату рождения, страну рождения, уровень образования и контактные данные." },
      { title: "Загрузите фотографию", desc: "Загрузите фото, соответствующее требованиям: 600×600 пикселей, белый фон, без очков." },
      { title: "Сохраните номер подтверждения", desc: "После отправки вы получите номер подтверждения. Сохраните его — это единственный способ проверить результаты." },
      { title: "Проверьте результаты в мае", desc: "Вернитесь на официальный сайт в мае. НЕ доверяйте письмам или звонкам о выигрыше — это мошенничество." },
    ],
    ctaChecklist: "Создать чек-лист заявки",
    mistakesLabel: "Частые ошибки",
    mistakesTitle: "Частые ошибки в лотерее DV",
    mistakes: [
      { title: "Неверный формат фото", desc: "Фотографии, не соответствующие спецификациям — причина №1 дисквалификации." },
      { title: "Потеря номера подтверждения", desc: "Без номера подтверждения невозможно проверить статус. Восстановить его нельзя." },
      { title: "Дублирование заявок", desc: "Подача более одной заявки на человека приведёт к дисквалификации всех заявок." },
      { title: "Неверные личные данные", desc: "Любое расхождение между заявкой и паспортом может привести к отказу в визе." },
    ],
    ctaCheckDocs: "Проверить мои документы",
    checklistLabel: "Подготовка",
    checklistTitle: "Чек-лист для лотереи DV",
    checklistIntro: "Убедитесь, что у вас всё готово до открытия регистрации:",
    checklistItems: [
      "Действующий паспорт с корректными биографическими данными",
      "Цифровое фото по спецификациям Госдепартамента (600×600 px)",
      "Аттестат о среднем образовании или эквивалент",
      "Документация об опыте работы (если применимо)",
      "Информация и фото супруга/детей (если применимо)",
      "Безопасное место для хранения номера подтверждения",
      "Доступ к компьютеру и интернету в период регистрации",
      "Закладка официального сайта: dvprogram.state.gov",
    ],
    ctaGenChecklist: "Создать мой чек-лист",
    compLabel: "Сравнение",
    compTitle: "Лотерея DV vs другие пути к Грин-карте",
    compIntro: "Как лотерея DV сравнивается с другими способами получения грин-карты?",
    compHeaders: ["Критерий", "Лотерея DV", "Семейная", "Рабочая"],
    compRows: [
      ["Стоимость", "Бесплатно", "$535+", "$700+"],
      ["Срок", "1–2 года", "1–20+ лет", "1–10+ лет"],
      ["Отбор", "Случайная лотерея", "По петиции", "Спонсор-работодатель"],
      ["Годовой лимит", "55 000 виз", "226 000 виз", "140 000 виз"],
      ["Требование", "Образование/Работа", "Семейные связи", "Предложение работы"],
      ["Сложность", "Удача", "Зависит от родства", "Зависит от работодателя"],
    ],
    ctaGuide: "Открыть гид по Грин-карте",
    faqLabel: "Часто задаваемые вопросы",
    faqTitle: "FAQ лотереи Грин-карт",
    faqs: [
      { q: "Что такое лотерея DV?", a: "Это программа правительства США, которая ежегодно случайным образом отбирает до 55 000 человек из стран с низким уровнем иммиграции." },
      { q: "Кто может участвовать?", a: "Граждане подходящих стран с аттестатом о среднем образовании или двумя годами квалифицированного опыта работы." },
      { q: "Когда открывается регистрация?", a: "Обычно в октябре, закрывается в ноябре. Проверяйте dvprogram.state.gov." },
      { q: "Сколько людей выигрывает?", a: "Около 55 000 виз, но отбирается более 100 000 для компенсации незавершённых заявок." },
      { q: "Что происходит после выигрыша?", a: "Нужно подать форму DS-260, собрать документы, пройти собеседование и медосмотр." },
      { q: "Могут ли члены семьи участвовать вместе?", a: "Каждый может подать свою заявку. Если один выиграет, супруг и дети до 21 года также получат грин-карты." },
      { q: "Какое фото требуется?", a: "Цифровое фото за последние 6 месяцев, 600×600 пикселей, белый фон, без очков." },
      { q: "Что если я потеряю номер подтверждения?", a: "Восстановить его невозможно. Сохраните его в нескольких безопасных местах сразу после регистрации." },
      { q: "Лотерея DV действительно случайная?", a: "Да. Отбор производится случайным компьютерным розыгрышем. Каждая заявка имеет равные шансы." },
      { q: "Участие бесплатное?", a: "Да, полностью бесплатно. Если кто-то просит оплату — это мошенничество." },
    ],
    finalTitle: "Начните свой иммиграционный путь сегодня",
    finalSubtitle: "Будь то лотерея DV или другие пути — ImmigrationGuide поможет вам на каждом шаге.",
    ctaFinalStart: "Бесплатный гид",
    ctaFinalEligibility: "Проверить право",
  },
  dvf: {
    badge: "Гид по заполнению формы DV",
    title: "Как правильно заполнить форму лотереи DV",
    titleHighlight: "Правильно",
    subtitle: "Пошаговые инструкции, правила фото и частые ошибки при подаче заявки на лотерею Грин-карт.",
    ctaEligibility: "Проверить право на участие",
    ctaChecklist: "Создать чек-лист заявки",
    beforeLabel: "Подготовка",
    beforeTitle: "Перед началом: что подготовить",
    beforeIntro: "Соберите следующую информацию и документы перед заполнением заявки.",
    beforeItems: [
      { title: "Личные данные", desc: "Полное имя (как в паспорте), дата рождения и город/страна рождения." },
      { title: "Данные о семье", desc: "Имена, даты и города рождения супруга/и и всех незамужних/неженатых детей до 21 года." },
      { title: "Данные об образовании", desc: "Наивысший уровень завершённого образования." },
      { title: "Страна рождения и право", desc: "Ваша страна рождения и, если отличается, страна, через которую заявляете право." },
      { title: "Цифровое фото", desc: "Фото по требованиям: 600×600 пикселей, белый фон, за последние 6 месяцев." },
      { title: "Хранение номера подтверждения", desc: "Подготовьте безопасное место для хранения номера подтверждения сразу после отправки." },
    ],
    fieldsLabel: "Инструкции по полям",
    fieldsTitle: "Пошаговая инструкция по заполнению формы DV",
    fieldsIntro: "Официальная форма на dvprogram.state.gov содержит следующие поля:",
    fields: [
      { title: "Полное имя", desc: "Введите имя как в паспорте. Сначала фамилия, затем имя, затем отчество." },
      { title: "Пол", desc: "Выберите мужской или женский, как указано в паспорте." },
      { title: "Дата рождения", desc: "Введите дату рождения в указанном формате. Проверьте совпадение с паспортом." },
      { title: "Город и страна рождения", desc: "Введите город и страну рождения. Используйте текущее название страны." },
      { title: "Страна права", desc: "Обычно это страна рождения. Если она не подходит, можно заявить через страну рождения супруга/и." },
      { title: "Загрузка фото", desc: "Загрузите фото: 600×600 пикселей, белый фон, без очков, недавнее." },
      { title: "Почтовый адрес", desc: "Введите полный адрес: улица, город, штат/область, индекс и страна." },
      { title: "Страна проживания", desc: "Выберите страну, где вы сейчас живёте." },
      { title: "Телефон", desc: "Введите номер с кодом страны. Необязательно, но рекомендуется." },
      { title: "Электронная почта", desc: "Введите действующий адрес. Госдеп НЕ отправляет результаты по почте." },
      { title: "Уровень образования", desc: "Выберите наивысший уровень. Минимум — аттестат о среднем образовании." },
      { title: "Семейное положение", desc: "Выберите текущее положение. Если женаты/замужем, укажите данные супруга/и." },
      { title: "Данные супруга/и", desc: "Укажите полное имя, дату рождения, пол, город/страну рождения и загрузите фото." },
      { title: "Данные о детях", desc: "Укажите всех незамужних/неженатых детей до 21 года, включая пасынков и приёмных." },
    ],
    photoLabel: "Требования к фото",
    photoTitle: "Правила фото для лотереи DV",
    photoIntro: "Фото — одна из самых критичных частей заявки. Неправильные фото — главная причина дисквалификации.",
    photoRules: [
      { title: "Свежее фото", desc: "За последние 6 месяцев. Старые фото будут отклонены." },
      { title: "Правильные размеры", desc: "Ровно 600×600 пикселей, квадратное, формат JPEG." },
      { title: "Однотонный фон", desc: "Только белый или почти белый фон. Без узоров и теней." },
      { title: "Без обработки", desc: "Без фильтров и ретуши. Без очков, шляп и головных уборов." },
    ],
    ctaPhotoCheck: "Проверить требования к фото",
    mistakesLabel: "Частые ошибки",
    mistakesTitle: "Частые ошибки в форме DV",
    mistakesIntro: "Избегайте этих ошибок:",
    mistakes: [
      { title: "Неверный формат фото", desc: "Всегда проверяйте фото через официальный инструмент." },
      { title: "Дублирование заявки", desc: "Более одной заявки на человека — дисквалификация ВСЕХ." },
      { title: "Не указан супруг или ребёнок", desc: "Все члены семьи должны быть включены." },
      { title: "Ошибки в именах", desc: "Имена должны точно совпадать с паспортом." },
      { title: "Неверная страна права", desc: "Выбор страны, на которую нет права." },
      { title: "Потеря номера подтверждения", desc: "Сохраните номер сразу. Без него результаты не проверить." },
    ],
    afterLabel: "После отправки",
    afterTitle: "Что происходит после отправки",
    afterIntro: "После отправки заявки:",
    afterSteps: [
      { title: "Сохраните номер подтверждения", desc: "Сохраните, сфотографируйте и запишите. Храните в 2–3 местах." },
      { title: "Проверяйте результаты онлайн", desc: "С мая на dvprogram.state.gov введите номер подтверждения." },
      { title: "Нет уведомлений по почте", desc: "Госдеп НЕ отправляет результаты по почте, письмом или звонком. Это мошенничество." },
      { title: "Остерегайтесь мошенников", desc: "Используйте только dvprogram.state.gov. Никогда не платите за результаты." },
    ],
    faqLabel: "Часто задаваемые вопросы",
    faqTitle: "FAQ по заполнению формы DV",
    faqs: [
      { q: "Как заполнить форму лотереи DV?", a: "Перейдите на dvprogram.state.gov в период регистрации. Заполните данные, загрузите фото, добавьте семью и отправьте." },
      { q: "Какое имя указывать?", a: "Полное имя как в паспорте. Сначала фамилия, затем имя." },
      { q: "Можно ли исправить после отправки?", a: "Нет. Можно отправить новую заявку, которая заменит предыдущую." },
      { q: "Какой размер фото?", a: "600×600 пикселей, JPEG, белый фон, за последние 6 месяцев." },
      { q: "Нужно ли включать супруга/у?", a: "Да, даже если он/она гражданин или резидент США." },
      { q: "Нужно ли включать детей?", a: "Да, всех незамужних/неженатых до 21 года." },
      { q: "Что если потерять номер подтверждения?", a: "Восстановить невозможно. Сохраните сразу в нескольких местах." },
      { q: "Когда можно подать заявку?", a: "Обычно октябрь–ноябрь. Даты на dvprogram.state.gov." },
      { q: "Заявка бесплатная?", a: "Да, полностью. Если просят оплату — это мошенничество." },
      { q: "Какую страну права выбрать?", a: "Обычно страну рождения. Если не подходит — страну рождения супруга/и." },
    ],
    finalTitle: "Начните подготовку к лотерее DV",
    finalSubtitle: "ImmigrationGuide поможет подготовить заявку с ИИ-помощником и пошаговыми инструкциями.",
    ctaFinalEligibility: "Проверить право",
    ctaFinalStart: "Бесплатный гид",
    ctaFinalChecklist: "Создать чек-лист",
  },
  billing: {
    checking: "Проверяем ваш платёж...",
    processingDesc: "Пожалуйста, подождите, пока мы подтвердим вашу подписку.",
    successTitle: "Оплата прошла успешно!",
    successDesc: "Ваша подписка Premium активна. Наслаждайтесь полным доступом ко всем функциям ИИ.",
    goToDashboard: "Перейти в панель управления",
    errorTitle: "Проблема с оплатой",
    errorDesc: "Не удалось подтвердить ваш платёж. Если средства были списаны, подписка активируется в ближайшее время.",
    cancelTitle: "Оплата отменена",
    cancelDesc: "Ваш платёж был отменён. Средства не были списаны.",
    backToPricing: "Вернуться к тарифам",
    checkoutError: "Не удалось начать оформление. Попробуйте ещё раз.",
    portalError: "Не удалось открыть управление подпиской.",
    redirecting: "Перенаправление...",
    currentPlan: "Текущий план",
    profileTitle: "Профиль",
    name: "Имя",
    email: "Эл. почта",
    authMethod: "Способ входа",
    plan: "Тариф",
    proPlan: "Premium",
    freePlan: "Бесплатный",
    subscriptionActive: "Подписка Premium активна",
    manageDesc: "Управляйте оплатой, обновите способ оплаты или отмените подписку.",
    manageSubscription: "Управление подпиской",
    upgradeToPremium: "Перейти на Premium",
    upgradeDesc: "ИИ-анализ, проверка документов, отслеживание сроков и многое другое за $15/мес.",
    upgradeNow: "Обновить сейчас",
    logoutSuccess: "Вы успешно вышли из системы",
    logout: "Выйти",
  },
  auth: {
    signInTitle: "С возвращением",
    registerTitle: "Начать",
    signInDesc: "Войдите в свой аккаунт",
    registerDesc: "Создайте аккаунт, чтобы начать навигацию по иммиграции в США",
    name: "Полное имя",
    namePh: "Введите ваше полное имя",
    email: "Электронная почта",
    emailPh: "Введите вашу почту",
    password: "Пароль",
    passwordPh: "Введите ваш пароль",
    signInBtn: "Войти",
    registerBtn: "Создать аккаунт",
    googleBtn: "Войти через Google",
    switchToRegister: "Нет аккаунта?",
    switchToSignIn: "Уже есть аккаунт?",
    register: "Регистрация",
    signIn: "Войти",
    signingIn: "Вход...",
    orContinueWith: "или продолжить с",
  },
  dashboard: {
    welcome: "С возвращением, ",
    subtitle: "Над чем вы хотите поработать сегодня?",
    continueTitle: "Продолжить с того места, где остановились",
    quickActionsTitle: "Быстрые действия",
    availableForms: "Доступные формы",
    viewAll: "Показать все",
    step: "Шаг",
    of: "из",
    actions: [
      { label: "Формы", desc: "Просмотр и объяснение государственных форм" },
      { label: "Маршруты", desc: "Этапы и сроки процессов" },
      { label: "Документы", desc: "Загрузка и управление документами" },
      { label: "Мой прогресс", desc: "Отслеживание вашего процесса" },
      { label: "Чек-листы", desc: "Список необходимых документов" },
      { label: "Сроки", desc: "Отслеживание важных дат" },
    ],
  },
  pages: {
    formsTitle: "Библиотека форм",
    formsSubtitle: "Просмотр государственных форм по категориям с объяснениями на базе ИИ.",
    catImmigration: "Иммиграция",
    catSocialSecurity: "Государственные услуги",
    catDmv: "Автоинспекция",
    diffEasy: "Лёгкий",
    diffMedium: "Средний",
    diffHard: "Сложный",
    startWizard: "Запустить помощник",
    backToForms: "Все формы",
    quickTip: "Совет:",
    commonMistakes: "Частые ошибки",
    explainWithAI: "Объяснить с ИИ",
    aiExplanation: "Объяснение ИИ",
    fieldRequired: "Обязательное",
    fieldQuestion: "Задайте вопрос по этому полю (необязательно)...",
    fields: "Полей:",
    estTimeline: "Ориентировочные сроки:",
    roadmapsTitle: "Маршруты процессов",
    roadmapsSubtitle: "Наглядные руководства по иммиграционным и государственным процессам.",
    backToRoadmaps: "Все маршруты",
    tips: "Советы:",
    checklistsTitle: "Чек-листы документов",
    checklistsSubtitle: "ИИ-генерируемые списки необходимых документов для ваших форм.",
    generate: "Создать",
    generateChecklist: "Создать чек-лист документов",
    selectForm: "Выберите форму",
    chooseForm: "Выберите форму...",
    yourSituation: "Ваша ситуация (необязательно)",
    situationPlaceholder: "Опишите вашу ситуацию для персонализированного чек-листа...",
    generateWithAI: "Создать с помощью ИИ",
    noChecklists: "Чек-листов пока нет",
    noChecklistsDesc: "Создайте свой первый чек-лист документов с помощью ИИ.",
    completed: "завершено",
    ofTotal: "из",
    deadlinesTitle: "Трекер сроков",
    deadlinesSubtitle: "Отслеживайте важные сроки подачи документов.",
    addDeadline: "Добавить срок",
    newDeadline: "Новый срок",
    deadlineTitle: "Название",
    deadlineDesc: "Описание (необязательно)",
    dueDate: "Дата сдачи",
    reminderDays: "Напоминание (за дней до)",
    save: "Сохранить",
    noDeadlines: "Сроков пока нет",
    noDeadlinesDesc: "Добавьте первый срок, чтобы ничего не пропустить.",
    overdue: "Просрочено",
    dueToday: "Сегодня",
    daysLeft: "дней осталось",
    documentsTitle: "Менеджер документов",
    documentsSubtitle: "Загружайте, организуйте и проверяйте иммиграционные документы.",
    uploadDocument: "Загрузить",
    uploadDialogTitle: "Загрузка документа",
    docFormLabel: "Связанная форма",
    docTypePlaceholder: "Выберите тип документа...",
    docTypes: "Паспорт,Свидетельство о рождении,Свидетельство о браке,Диплом,Письмо от работодателя,Финансовый документ,Фото,Другое",
    dragDrop: "Перетащите файл или нажмите для выбора",
    maxFileSize: "PDF, JPG, PNG до 10МБ",
    uploading: "Загрузка...",
    upload: "Загрузить",
    noDocs: "Документов пока нет",
    noDocsDesc: "Загрузите первый документ для начала работы.",
    validateDocs: "Проверить документы",
    validating: "Проверка...",
    validateForForm: "Выберите форму для проверки документов на соответствие требованиям.",
    selectFormFirst: "Сначала выберите форму",
    aiValidation: "ИИ-проверка документов",
    proFeature: "Функция Pro",
    timelineTitle: "Мой прогресс",
    timelineSubtitle: "Отслеживайте ваш прогресс в иммиграционных процессах.",
    selectProcess: "Выберите процесс для отслеживания",
    trackProcess: "Отслеживать процесс",
    saveProgress: "Сохранить прогресс",
    saving: "Сохранение...",
    currentStep: "Текущий этап",
    notes: "Заметки",
    notesPlaceholder: "Добавьте заметки о вашем прогрессе...",
    progressSaved: "Прогресс сохранён!",
    noTimelines: "Процессов пока нет",
    noTimelinesDesc: "Выберите процесс для отслеживания прогресса.",
    wizardComplete: "Форма заполнена!",
    wizardCompleteDesc: "Вы заполнили все поля для",
    checkForErrors: "Проверить ошибки",
    aiAnalysis: "ИИ-анализ (Pro)",
    generateDocChecklist: "Создать чек-лист",
    aiAnalysisInsights: "ИИ-анализ и рекомендации",
    confidence: "Уверенность:",
    estProcessingTime: "Ориент. срок обработки",
    riskLevel: "Уровень риска",
    potentialIssues: "Возможные проблемы:",
    recommendations: "Рекомендации:",
    nextSteps: "Следующие шаги:",
    noErrorsDetected: "Ошибок не найдено! Ваши ответы выглядят хорошо.",
    foundIssues: "возможных проблем(ы)",
    backToDashboard: "Назад к панели",
    exitWizard: "Выход",
    stepOf: "Шаг {current} из {total}",
    yourAnswer: "Ваш ответ",
    selectOption: "Выберите вариант...",
    typeAnswer: "Введите ваш ответ...",
    watchOut: "Обратите внимание",
    skip: "Пропустить",
    finish: "Завершить",
    next: "Далее",
    thisFieldRequired: "Это поле обязательно",
    startGuided: "Запустить помощник",
  },
  dvd: {
    badge: "Даты лотереи DV",
    heroTitle: "Даты и график регистрации лотереи DV",
    heroSubtitle: "Узнайте, когда открывается лотерея Green Card, когда объявляются результаты и что происходит дальше в процессе DV.",
    ctaEligibility: "Проверить право на участие в DV",
    ctaStartGuide: "Начать бесплатно",
    regLabel: "Регистрация",
    regTitle: "Период регистрации лотереи DV",
    regPeriodTitle: "Окно регистрации: октябрь – ноябрь",
    regPeriodDesc: "Период регистрации лотереи DV обычно проходит каждый год в октябре и ноябре. Окно онлайн-заявки открыто примерно 30 дней. В это время подходящие кандидаты могут подать заявки через официальный сайт dvprogram.state.gov.",
    regOfficialTitle: "Официальные даты объявляются ежегодно",
    regOfficialDesc: "Точные даты регистрации объявляются Государственным департаментом США на официальном сайте (dvprogram.state.gov). Даты немного меняются каждый год, поэтому всегда проверяйте официальный источник.",
    tlLabel: "Хронология",
    tlTitle: "Хронология лотереи DV",
    timelineItems: [
      { period: "Октябрь – Ноябрь", title: "Период регистрации", desc: "Окно онлайн-регистрации открывается на dvprogram.state.gov. Кандидаты подают личную информацию, фото и данные о семье." },
      { period: "Май", title: "Объявление результатов", desc: "Начиная с мая кандидаты могут проверить статус отбора онлайн, используя номер подтверждения." },
      { period: "Октябрь – Сентябрь", title: "Обработка визы", desc: "Отобранные кандидаты проходят визовую обработку в течение финансового года, включая DS-260, подготовку документов и собеседование в посольстве." },
    ],
    ctaTimeline: "Проверить хронологию Green Card",
    resLabel: "Результаты",
    resTitle: "Когда объявляются результаты лотереи DV",
    resCheckTitle: "Проверьте результаты по номеру подтверждения",
    resCheckDesc: "Начиная с мая каждого года кандидаты могут проверить, были ли они отобраны, посетив dvprogram.state.gov и введя номер подтверждения. Это единственный способ узнать, были ли вы выбраны.",
    resNoEmailTitle: "Уведомления по электронной почте не отправляются",
    resNoEmailDesc: "Правительство США не отправляет электронные письма, почту или звонки для уведомления победителей лотереи. Любое сообщение о выигрыше в лотерее DV — это мошенничество.",
    ctaCheckResults: "Как проверить результаты DV",
    afterLabel: "После выигрыша",
    afterTitle: "Что происходит после выигрыша в лотерее",
    afterIntro: "Если вы отобраны в лотерее DV, вам необходимо выполнить несколько шагов для получения иммиграционной визы:",
    afterSteps: [
      { title: "Подать форму DS-260", desc: "Заполните и отправьте онлайн-заявку на иммиграционную визу (форма DS-260) через Консульский электронный центр заявок." },
      { title: "Подготовка документов", desc: "Соберите все необходимые документы, включая паспорт, свидетельство о рождении, справку о несудимости и образовательные документы." },
      { title: "Собеседование в посольстве", desc: "Пройдите личное собеседование в посольстве или консульстве США в вашей стране." },
      { title: "Выдача визы", desc: "При одобрении иммиграционная виза будет вклеена в ваш паспорт. Вы должны въехать в США до истечения срока визы." },
    ],
    ctaAfterWinning: "Что делать после выигрыша",
    guidesLabel: "Руководства по лотерее DV",
    guidesTitle: "Руководства по лотерее DV",
    guides: [
      { title: "Руководство по лотерее Green Card", desc: "Полный обзор программы DV, право на участие и как подать заявку." },
      { title: "Как заполнить форму DV", desc: "Пошаговые инструкции по правильному заполнению заявки." },
      { title: "Требования к фото DV", desc: "Точные требования к фото и распространённые ошибки." },
      { title: "Распространённые ошибки лотереи DV", desc: "Самые частые ошибки, ведущие к дисквалификации." },
      { title: "Как проверить результаты DV", desc: "Где и когда проверить статус отбора." },
      { title: "Что делать после выигрыша", desc: "Пошаговое руководство по визовой обработке после отбора." },
      { title: "Право на участие в лотерее DV", desc: "Проверьте, какие страны имеют право, и какие требования применяются." },
    ],
    faqLabel: "Часто задаваемые вопросы",
    faqTitle: "Часто задаваемые вопросы о датах DV",
    faqs: [
      { q: "Когда открывается регистрация лотереи DV?", a: "Регистрация обычно открывается в начале октября каждого года. Точные даты объявляются на dvprogram.state.gov." },
      { q: "Когда выходят результаты лотереи DV?", a: "Результаты обычно доступны начиная с мая. Проверьте на dvprogram.state.gov с вашим номером подтверждения." },
      { q: "Сколько длится процесс DV?", a: "От регистрации до получения визы весь процесс обычно занимает от 1 до 2 лет." },
      { q: "Можно ли подавать на лотерею DV каждый год?", a: "Да, вы можете подавать каждый год, если соответствуете требованиям." },
      { q: "Нужен ли паспорт для лотереи DV?", a: "Паспорт не нужен для регистрации, но он понадобится позже для заявки DS-260 и собеседования." },
      { q: "Сколько людей выигрывают в лотерее?", a: "Ежегодно доступно около 55 000 виз разнообразия. Отбирается более 100 000 человек для компенсации тех, кто не завершает процесс." },
      { q: "Бесплатна ли лотерея DV?", a: "Да, участие полностью бесплатно. Если кто-то просит оплату за регистрацию — это мошенничество." },
      { q: "Могут ли супруги подавать отдельно?", a: "Да, каждый супруг может подать свою заявку. Если один выбран, другой может быть включён как производный заявитель." },
    ],
    finalTitle: "Продолжите свой иммиграционный путь с ImmigrationGuide",
    finalSubtitle: "Готовитесь к лотерее DV или исследуете другие пути иммиграции — ImmigrationGuide помогает вам на каждом шагу.",
  },
  dvp: {
    badge: "Требования к фото",
    heroTitle: "Руководство по требованиям к фото для лотереи DV",
    heroSubtitle: "Узнайте правильный размер, формат и правила фотографии для заявки на лотерею Green Card.",
    ctaEligibility: "Проверить право на участие в DV",
    ctaFormGuide: "Как заполнить форму DV",
    ctaChecklist: "Создать список документов",
    ctaStartPrep: "Начать подготовку к DV",
    rulesLabel: "Правила фото",
    rulesTitle: "Официальные правила фото для лотереи DV",
    rulesIntro: "Государственный департамент США предъявляет строгие требования к фотографиям для лотереи DV. Фотографии, не соответствующие правилам, приведут к автоматической дисквалификации.",
    rules: [
      { title: "Квадратное фото", desc: "Ваша фотография должна быть идеальным квадратом: ровно 600 x 600 пикселей. Неквадратные изображения будут автоматически отклонены." },
      { title: "Однотонный фон", desc: "Фон должен быть белым или почти белым. Не допускаются узоры, мебель, тени или другие люди позади вас." },
      { title: "Свежее фото", desc: "Фотография должна быть сделана в течение последних 6 месяцев. Если ваша внешность значительно изменилась, нужна новая фотография." },
      { title: "Без фильтров и обработки", desc: "Цифровые фильтры, ретушь, режим красоты или любая форма обработки изображения не допускаются." },
    ],
    specsLabel: "Спецификации",
    specsTitle: "Размер и формат фото",
    specsIntro: "Ваша фотография для лотереи DV должна соответствовать следующим техническим спецификациям:",
    specs: [
      { title: "Разрешение: 600 x 600 пикселей", desc: "Изображение должно быть ровно 600 пикселей в ширину и 600 пикселей в высоту. Фотографии с низким разрешением будут размытыми и отклонены." },
      { title: "Формат: JPEG (.jpg)", desc: "Фотография должна быть в формате JPEG. Другие форматы, такие как PNG, BMP, TIFF или HEIC, не принимаются." },
      { title: "Размер файла: максимум 240 КБ", desc: "Файл фотографии не должен превышать 240 килобайт. Если файл слишком большой, слегка уменьшите качество." },
    ],
    mistakesLabel: "Частые ошибки",
    mistakesTitle: "Частые ошибки с фото",
    mistakesIntro: "Это наиболее частые ошибки с фотографиями, приводящие к дисквалификации на лотерее DV:",
    mistakes: [
      { title: "Неправильный фон", desc: "Использование цветного, узорчатого или загруженного фона вместо однотонного белого." },
      { title: "Тени на лице или фоне", desc: "Видимые тени на лице, за головой или на фоновой стене. Используйте равномерное фронтальное освещение." },
      { title: "Обрезанная или слишком маленькая голова", desc: "Голова должна занимать 50-69% высоты изображения. Обрезанная или слишком маленькая голова приведёт к отказу." },
      { title: "Обработанные или отфильтрованные изображения", desc: "Любая цифровая обработка — фильтры красоты, сглаживание кожи, коррекция красных глаз — приведёт к дисквалификации." },
    ],
    guidelinesLabel: "Позиционирование",
    guidelinesTitle: "Примеры правил для фото",
    guidelinesIntro: "Следуйте этим правилам позиционирования и кадрирования:",
    guidelines: [
      { title: "Положение головы", desc: "Голова должна быть по центру кадра и смотреть прямо вперёд. Не наклоняйте и не поворачивайте голову. Оба уха должны быть видны." },
      { title: "Уровень глаз", desc: "Глаза должны находиться на уровне 56-69% высоты изображения, измеренной снизу." },
      { title: "Высота головы", desc: "Голова (от подбородка до макушки) должна занимать 50-69% общей высоты изображения." },
      { title: "Выражение лица", desc: "Сохраняйте естественное, нейтральное выражение с закрытым ртом. Лёгкая естественная улыбка допустима." },
      { title: "Без аксессуаров", desc: "Снимите очки (даже прозрачные), шляпы, наушники и любые предметы, закрывающие лицо. Религиозные головные уборы — единственное исключение." },
    ],
    faqLabel: "Часто задаваемые вопросы",
    faqTitle: "Часто задаваемые вопросы о фото DV",
    faqs: [
      { q: "Какой размер фото требуется для лотереи DV?", a: "Фото должно быть ровно 600 x 600 пикселей в формате JPEG, максимальный размер файла 240 КБ. Должно быть свежим, сделанным в последние 6 месяцев." },
      { q: "Можно ли носить очки на фото для лотереи DV?", a: "Нет. С 2016 года Госдепартамент не разрешает очки на фото для лотереи DV, даже прозрачные с диоптриями." },
      { q: "Какой цвет фона использовать?", a: "Фон должен быть белым или почти белым. Никакие другие цвета, узоры или объекты не должны быть видны." },
      { q: "Можно ли редактировать или ретушировать фото?", a: "Нет. Любое цифровое редактирование, ретушь, фильтр красоты или цветокоррекция дисквалифицирует вашу фотографию." },
      { q: "Можно ли сделать фото на телефон?", a: "Да, можно использовать камеру смартфона, если фото соответствует всем требованиям: 600x600 пикселей, формат JPEG, белый фон." },
      { q: "Как проверить, соответствует ли моё фото требованиям?", a: "Госдепартамент предоставляет официальный инструмент проверки фото на сайте dvprogram.state.gov." },
      { q: "Можно ли носить религиозный головной убор?", a: "Да, религиозные головные уборы разрешены, если вы носите их ежедневно. Однако ваше лицо полностью должно быть видно." },
      { q: "Что произойдёт, если моё фото будет отклонено?", a: "Если фото не соответствует требованиям, вся ваша заявка на лотерею DV будет дисквалифицирована. Всегда проверяйте фото перед отправкой." },
    ],
    finalTitle: "Начните подготовку к лотерее DV",
    finalSubtitle: "ImmigrationGuide помогает подготовить заявку на лотерею DV с помощью ИИ, списков документов и пошаговых инструкций.",
  },
  pricing: {
    badge: "Цены",
    pageTitle: "Простые и прозрачные цены",
    subtitle: "Начните бесплатно с доступом к руководствам и базовым функциям. Обновите, когда понадобятся анализ и валидация с помощью ИИ.",
    freeName: "Бесплатный",
    freeDesc: "Идеально для начала",
    proName: "Премиум",
    proDesc: "Полная навигация с помощью ИИ",
    month: "месяц",
    popular: "Самый популярный",
    freeBtn: "Начать бесплатно",
    proBtn: "Начать Премиум",
    footer: "Все планы включают доступ к нашим руководствам по формам и дорожным картам. Отмена в любое время. Без контрактов.",
    freeFeatures: [
      { name: "Доступ ко всем руководствам по формам", included: true },
      { name: "Базовый помощник ИИ", included: true },
      { name: "Дорожные карты процессов", included: true },
      { name: "Загрузка и хранение документов", included: true },
      { name: "Руководства по водительским правам по штатам", included: true },
      { name: "Анализ и рекомендации ИИ", included: false },
      { name: "Валидация документов с помощью ИИ", included: false },
      { name: "Персонализированные чеклисты", included: false },
      { name: "Отслеживание хронологии", included: false },
      { name: "Отслеживание сроков", included: false },
    ],
    proFeatures: [
      { name: "Всё из бесплатного плана" },
      { name: "Анализ ИИ и персонализированные рекомендации" },
      { name: "Валидация документов с помощью ИИ" },
      { name: "Отслеживание хронологии" },
      { name: "Персонализированные чеклисты" },
      { name: "Отслеживание сроков и напоминания" },
      { name: "Обнаружение ошибок и предупреждения" },
      { name: "Приоритетные ответы ИИ" },
    ],
  },
  dvNav: {
    label: "Руководства по лотерее DV",
    title: "Руководства по лотерее DV",
    current: "Вы здесь",
    toolsLabel: "Инструменты ImmigrationGuide",
    guides: [
      { title: "Руководство по лотерее Green Card" },
      { title: "Даты лотереи DV" },
      { title: "Требования к фото" },
      { title: "Как заполнить форму" },
      { title: "Частые ошибки" },
      { title: "Как проверить результаты" },
      { title: "Что делать после выигрыша" },
      { title: "Проверка права на участие" },
    ],
    tools: ["Руководство Green Card", "Калькулятор сроков", "Помощник по иммиграции", "Список документов"],
  },
  dvw: {
    badge: "После выигрыша в лотерее DV",
    heroTitle: "Что делать после выигрыша в лотерее DV",
    heroSubtitle: "Пошаговое руководство для победителей лотереи DV: от подтверждения выбора до получения иммиграционной визы и Green Card.",
    ctaChecklist: "Создать список документов",
    ctaTimeline: "Проверить хронологию Green Card",
    ctaStartGuide: "Начать руководство по иммиграции",
    confirmLabel: "Шаг 1",
    confirmTitle: "Подтвердите свой выбор",
    confirmCheckTitle: "Проверьте результаты по номеру подтверждения",
    confirmCheckDesc: "Перейдите на официальный сайт лотереи DV dvprogram.state.gov и введите номер подтверждения, полученный при подаче заявки. Это единственный законный способ проверить, были ли вы выбраны.",
    confirmScamTitle: "Остерегайтесь мошенничества",
    confirmScamDesc: "Правительство США не уведомляет победителей лотереи DV по электронной почте, телефону или письмом. Любое сообщение о выигрыше — мошенничество. Используйте только dvprogram.state.gov.",
    ds260Label: "Шаг 2",
    ds260Title: "Подать форму DS-260",
    ds260Intro: "После подтверждения выбора ваш следующий шаг — заполнить и отправить онлайн-заявку на иммиграционную визу.",
    ds260WhatTitle: "Что такое форма DS-260?",
    ds260WhatDesc: "Форма DS-260 — это онлайн-заявка на иммиграционную визу, которую должны заполнить все отобранные в лотерее DV. Она собирает подробную личную информацию, историю поездок, опыт работы, образование, семейные данные и вопросы безопасности.",
    ds260InfoTitle: "Необходимая информация",
    ds260InfoDesc: "Для заполнения DS-260 вам понадобятся: данные паспорта, история поездок за последние 5 лет, трудовая история за последние 10 лет, история образования, адреса за последние 5 лет, семейная информация и ваш контакт в США.",
    docsLabel: "Шаг 3",
    docsTitle: "Подготовьте документы",
    docsIntro: "Вам необходимо собрать несколько оригинальных документов для собеседования в посольстве. Все документы не на английском языке должны включать заверенные переводы.",
    docs: [
      { title: "Свидетельство о рождении", desc: "Оригинал свидетельства о рождении с заверенным переводом на английский, если он не на английском." },
      { title: "Действующий паспорт", desc: "Паспорт, действительный не менее 6 месяцев после планируемой даты въезда в США." },
      { title: "Справка о несудимости", desc: "Справки из полиции каждой страны, где вы проживали 12 месяцев или более с 16 лет." },
      { title: "Подтверждение образования", desc: "Диплом о среднем образовании или эквивалент, а также сертификаты о высшем образовании." },
      { title: "Медицинский осмотр", desc: "Пройдите медосмотр у врача, одобренного посольством США." },
      { title: "Фотографии", desc: "Две недавние фотографии паспортного размера для каждого заявителя. Белый фон, без очков." },
      { title: "Подтверждение финансовой поддержки", desc: "Форма I-134 от финансового спонсора в США или доказательство достаточных личных средств." },
      { title: "Документы о браке и семье", desc: "Свидетельство о браке, свидетельства о разводе или смерти и свидетельства о рождении всех детей." },
    ],
    interviewLabel: "Шаг 4",
    interviewTitle: "Подготовка к собеседованию",
    interviewIntro: "Собеседование в посольстве — последний основной шаг в процессе визы лотереи DV.",
    interviewSchedTitle: "Назначение собеседования",
    interviewSchedDesc: "После отправки DS-260 и всех документов Консульский центр Кентукки назначит ваше собеседование. Вы получите уведомление с датой, временем и местом. Собеседования назначаются по номеру дела. Всё должно быть завершено до 30 сентября.",
    interviewPrepTitle: "Что ожидать в посольстве",
    interviewPrepDesc: "Приходите рано со всеми оригиналами документов. Собеседование длится 10-20 минут. Консульский офицер проверит вашу личность, документы и задаст вопросы о вашей биографии. Будьте честны и прямы.",
    bulletinLabel: "Шаг 5",
    bulletinTitle: "Визовый бюллетень и номера дел",
    bulletinIntro: "Понимание вашего номера дела и Визового бюллетеня критически важно для отслеживания прогресса в процессе лотереи DV.",
    bulletinCaseTitle: "Как работают номера дел",
    bulletinCaseDesc: "При выборе вы получаете номер дела, определяющий, когда будет назначено собеседование. Госдепартамент публикует ежемесячный Визовый бюллетень, показывающий, какие номера обрабатываются. Все визы DV должны быть выданы до 30 сентября.",
    faqLabel: "Часто задаваемые вопросы",
    faqTitle: "Часто задаваемые вопросы после выигрыша",
    faqs: [
      { q: "Какой крайний срок после выигрыша в лотерее DV?", a: "Все визы должны быть выданы до 30 сентября финансового года. Продлений нет." },
      { q: "Сколько длится процесс визы DV?", a: "От выбора до выдачи визы процесс занимает от 6 до 12 месяцев в зависимости от номера дела." },
      { q: "Что происходит на собеседовании в посольстве?", a: "Консульский офицер проверяет документы, идентичность и задаёт вопросы о вашей биографии. Длится 10-20 минут." },
      { q: "Могу ли я взять семью?", a: "Да. Ваш супруг и неженатые дети до 21 года могут получить производные визы DV." },
      { q: "Что если я не могу прийти на собеседование?", a: "Свяжитесь с посольством как можно скорее для перенаправления. Все визы должны быть выданы до 30 сентября." },
      { q: "Нужен ли финансовый спонсор?", a: "Вы должны доказать, что не станете «бременем для общества» через I-134, личные сбережения или предложение работы." },
      { q: "Что такое Визовый бюллетень?", a: "Ежемесячная публикация, показывающая, какие номера дел DV обрабатываются в настоящее время." },
      { q: "Что происходит после одобрения собеседования?", a: "Паспорт возвращается с запечатанной иммиграционной визой через 1-2 недели. Вы должны въехать в США до истечения срока." },
    ],
    finalTitle: "Навигация по DV с ImmigrationGuide",
    finalSubtitle: "От подготовки DS-260 до собеседования — ImmigrationGuide ведёт вас на каждом шагу.",
  },
  dvm: {
    badge: "Частые ошибки",
    heroTitle: "Частые ошибки лотереи DV",
    heroSubtitle: "Избегайте самых распространённых ошибок, приводящих к дисквалификации в лотерее DV. Узнайте, на что обратить внимание перед подачей заявки.",
    ctaEligibility: "Проверить право на участие",
    ctaFormGuide: "Как заполнить форму DV",
    ctaChecklist: "Проверить мой список",
    ctaStartGuide: "Начать бесплатно",
    mistakeLabel: "Ошибка",
    tipLabel: "Как избежать:",
    sections: [
      { title: "Дублирование заявок", subtitle: "Подача нескольких заявок", desc: "Подача нескольких заявок на лотерею DV — одна из самых распространённых и серьёзных ошибок. Госдепартамент использует ПО для обнаружения дубликатов. Все заявки от такого человека дисквалифицируются навсегда.", tip: "Подавайте только одну заявку в год. При ошибке можно подать новую в период регистрации — она заменит предыдущую." },
      { title: "Ошибки в фото", subtitle: "Неправильный формат, фон или обработка", desc: "Ошибки с фото — причина номер один дисквалификации. Требуется: ровно 600x600 пикселей, формат JPEG, белый фон, сделано за последние 6 месяцев, без очков, без головных уборов, без обработки.", tip: "Всегда используйте официальный инструмент проверки фото на dvprogram.state.gov перед отправкой." },
      { title: "Пропущенные члены семьи", subtitle: "Не указан супруг или дети", desc: "Все заявители должны указать супруга и всех неженатых детей до 21 года — даже если они не будут иммигрировать с вами.", tip: "Укажите всех требуемых членов семьи, независимо от их текущего иммиграционного статуса." },
      { title: "Неверные личные данные", subtitle: "Ошибки в имени или стране рождения", desc: "Любое расхождение между данными заявки и официальными документами может привести к отказу в визе.", tip: "Копируйте информацию непосредственно из паспорта. Проверяйте каждое поле перед отправкой." },
      { title: "Потеря номера подтверждения", subtitle: "Без него невозможно проверить результаты", desc: "После подачи заявки вы получаете уникальный номер подтверждения. Это единственный способ проверить, выбраны ли вы. При потере восстановить его невозможно.", tip: "Сразу после подачи: сделайте скриншот, запишите на бумаге, сохраните в email и в приложении заметок. Сохраните минимум в 3 местах." },
    ],
    faqLabel: "Часто задаваемые вопросы",
    faqTitle: "Частые вопросы об ошибках DV",
    faqs: [
      { q: "Какая самая частая ошибка лотереи DV?", a: "Ошибки с фото — самая частая причина дисквалификации." },
      { q: "Могу ли я быть дисквалифицирован за дублирование?", a: "Да. Если система обнаружит более одной заявки, все будут дисквалифицированы." },
      { q: "Что будет, если я забуду указать супруга?", a: "Вам могут отказать в визе на собеседовании, даже если вы были выбраны." },
      { q: "Могу ли я исправить заявку после отправки?", a: "Нельзя редактировать, но можно подать новую в период регистрации." },
      { q: "Что если моё имя написано по-разному в документах?", a: "Используйте написание из паспорта в форме DV." },
      { q: "Можно ли восстановить потерянный номер подтверждения?", a: "Нет. Восстановить потерянный номер невозможно." },
      { q: "Дисквалифицирует ли фото в очках?", a: "Да. С 2016 года очки не допускаются на фото лотереи DV." },
      { q: "Может ли кто-то подать заявку за меня?", a: "Кто-то может помочь, но вы отвечаете за то, чтобы была подана только одна заявка." },
    ],
    finalTitle: "Подавайте с уверенностью с ImmigrationGuide",
    finalSubtitle: "Избегайте частых ошибок и правильно подготовьте заявку с помощью ИИ.",
  },

  trust: {
    title: "Ваши данные в безопасности",
    encryptedTitle: "Сквозное шифрование",
    encryptedDesc: "Все данные шифруются при передаче (TLS) и хранении (AES-256). Ваша информация никогда не хранится в открытом виде.",
    independentTitle: "Независимый и конфиденциальный",
    independentDesc: "Мы не связаны с USCIS или какими-либо государственными органами и никогда не передаём ваши данные государственным органам.",
    deleteTitle: "Удаление в любое время",
    deleteDesc: "Запросите полное удаление данных в любое время.",
    deleteLink: "Политика конфиденциальности и удаления",
  },
  legal: {
    banner: "ImmigrationGuide не является юридической фирмой и не предоставляет юридических консультаций. Не связан с USCIS или государственными органами.",
  },
};
